'use client';

export function MeshGradient() {
  return (
    <div className="absolute inset-0 overflow-hidden">
      {/* Deep blue orb — top left */}
      <div
        className="absolute -top-1/4 -left-1/4 w-[70%] h-[70%] rounded-full opacity-[0.18] blur-[100px] animate-mesh-drift-1"
        style={{
          background:
            'radial-gradient(circle, hsl(221 83% 53%) 0%, transparent 70%)',
        }}
      />

      {/* Lighter blue orb — bottom right */}
      <div
        className="absolute -bottom-1/4 -right-1/4 w-[60%] h-[60%] rounded-full opacity-[0.14] blur-[100px] animate-mesh-drift-2"
        style={{
          background:
            'radial-gradient(circle, hsl(217 91% 60%) 0%, transparent 70%)',
        }}
      />

      {/* Indigo orb — center */}
      <div
        className="absolute top-1/3 left-1/4 w-[50%] h-[50%] rounded-full opacity-[0.10] blur-[100px] animate-mesh-drift-3"
        style={{
          background:
            'radial-gradient(circle, hsl(234 89% 60%) 0%, transparent 70%)',
        }}
      />

      {/* Cyan accent orb — top right */}
      <div
        className="absolute -top-[15%] right-1/4 w-[40%] h-[40%] rounded-full opacity-[0.08] blur-[80px] animate-mesh-drift-4"
        style={{
          background:
            'radial-gradient(circle, hsl(199 89% 48%) 0%, transparent 70%)',
        }}
      />

      {/* Noise overlay */}
      <div
        className="absolute inset-0 opacity-[0.035]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
        }}
      />

      {/* Geometric facet lines */}
      <div className="absolute top-16 right-16 w-40 h-40 border border-white/[0.04] rotate-45" />
      <div className="absolute bottom-24 left-20 w-28 h-28 border border-white/[0.06] rotate-12" />
      <div className="absolute top-1/2 right-1/3 w-20 h-20 border border-white/[0.03] -rotate-[30deg]" />
    </div>
  );
}
